import { FilterOption } from "../types";
import SearchInput from "./search-input";
import Filter from "./filter";

interface PatientLogFiltersProps {
    searchValue: string;
    onSearchChange: (value: string) => void;
    filterValue: string;
    onFilterChange: (value: string) => void;
    filterOptions: FilterOption[];
    verificationValue: string;
    verificationOptions: FilterOption[];
    onVerificationChange: (value: string) => void;
}

export const PatientLogFilters = ({
    searchValue,
    onSearchChange,
    filterValue,
    onFilterChange,
    filterOptions,
    verificationValue,
    verificationOptions,
    onVerificationChange
}: PatientLogFiltersProps) => {
    return (
        <div className="flex flex-col-reverse md:flex-row justify-between w-full items-start md:items-center gap-4 md:gap-[32px]">
            <SearchInput 
                value={searchValue} 
                setValue={onSearchChange} 
                placeholder="Search by name or email" 
            />
           <div className="flex flex-row items-center gap-[16px] justify-between md:justify-end w-full md:w-auto h-fit">
            <Filter 
                label="Filter" 
                options={filterOptions} 
                value={filterValue} 
                onValueChange={onFilterChange}
                placeholder="Payment Status"
            />
            <Filter
              label="VerificationFilter"
              options={verificationOptions}
              value={verificationValue}
              onValueChange={onVerificationChange}
              placeholder="Verification Status"
            />
            </div>
        </div>
    );
}; 